import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import Button from "./src/button.vue";
import ButtonIcon from "./src/button-icon.vue";
export const xButton = withInstall(Button, { ButtonIcon });
export default xButton;
export const xButtonIcon = withNoopInstall(ButtonIcon);
export * from "./src/button";
export * from "./src/button-icon";
